export function isNotUndefined<T>(possiblyUndefined: T | undefined): possiblyUndefined is T {
    return possiblyUndefined !== undefined;
}